/**
 * @Description
 */
import { FC, useMemo, useState } from 'react';
import styles from './index.module.less';
import { Col, Row } from 'antd';
import Info from 'src/views/youth/pages/map/components/LeftContent/components/Info';
import { beautifyThePrice, isNotEmptyAny, isUndef } from '@lhb/func';
// import TableList from 'src/views/youth/pages/map/components/LeftContent/components/TableList';
import { useMethods } from '@lhb/hook';
// import CompetitorData from './CompetitorData';
import MacroModal from 'src/views/youth/pages/map/components/LeftContent/ProvinceDimension/MacroModal';
// import StatisticsCardGroup from '../../components/StatisticsCard/Group';
// import StatisticsCard from '../../components/StatisticsCard';
import CommonBrandModule from 'src/views/youth/pages/map/components/LeftContent/components/CommonBrandModule/index';
import StoreInfoCardV2 from './components/StoreInfoCardV2';
import V2Title from '@/common/components/Feedback/V2Title';
import CarInsuranceAmount from '@/views/youth/pages/map/components/LeftContent/components/CarInsuranceAmount';
import IconFont from '@/common/components/IconFont';



/** 点位-城市信息 */
const CityInfo: FC<{
  cityInfo: any;
  drawerData: any;
  competitorInfo: any;
  attentionBrandTopData: any[]; // 关注品牌Top6数据
  statesTabs: any[];
  showPlanningBoard: boolean; // 是否展示规划看板
  mainHeight: any;
  /** 是否展示车保金额 */
  showCarInsuranceVolume: boolean;
  planData?: any[];
  tenantId?: string;
}> = ({
  cityInfo = {},
  drawerData = {},
  // planData = [],
  competitorInfo,
  statesTabs,
  // showPlanningBoard, // 是否展示规划看板
  attentionBrandTopData,
  mainHeight,
  showCarInsuranceVolume,
  tenantId
}) => {
  const [open, setOpen] = useState<boolean>(false); // 省宏观数据弹窗

  const carInsuranceAmountFilter = useMemo(() => {
    return {
      province: {
      },
      city: {
        id: cityInfo?.cityId,
        name: cityInfo?.name,
      },
    };
  }, [cityInfo]);

  const methods = useMethods({
    infoFactor(info) {
      if (isUndef(info)) {
        return '-';
      } else if (+info === parseInt(info)) {
        return beautifyThePrice(info, undefined, 0);
      } else if (Number(info) <= 0.05) {
        // 小于等于0.05时直接显示0.05
        return info;
      } else {
        return beautifyThePrice(info, undefined, 1);
      }
    },
    // 点击查看宏观数据
    onRightIconClick() {
      setOpen(true);
    },
  });


  return (
    <div className={styles.cityInfo} style={{ height: mainHeight }}>
      {
        (
          <>
            <V2Title type='H2' text='门店情况' className={styles.title}/>
            <StoreInfoCardV2 list={statesTabs} />
          </>
        )
      }
      {!!showCarInsuranceVolume && <CarInsuranceAmount
        inSpotevaluation
        filter={carInsuranceAmountFilter}
        tenantId={tenantId}
        userId={drawerData?.userId}
      />}
      <div className={styles.titleCon} onClick={methods.onRightIconClick}>
        <V2Title type='H2' text={`${cityInfo?.name}信息`} className={styles.title}/>
        <IconFont iconHref='pc-common-icon-ic_arrow_right' className={styles.icon}/>
      </div>
      <Row className={styles.infoGroup} gutter={[8, 10]}>
        <Col span={6}>
          <Info text={`常住人口`} num={methods.infoFactor(cityInfo?.population)} unit='万人' icon='iconic_renkou'></Info>
        </Col>
        <Col span={6}>
          <Info text={`全市GDP`} num={methods.infoFactor(cityInfo?.gdp)} unit='亿元' icon='iconic_GDP'></Info>
        </Col>
        <Col span={6}>
          <Info text={`人均GDP`} num={methods.infoFactor(cityInfo?.avgGdp)} unit='万元' icon='iconic_renjun'></Info>
        </Col>
        <Col span={6}>
          <Info text={`GDP增速`} num={methods.infoFactor(cityInfo?.gdpGrowthRate)} unit='%' icon='iconic_suzeng'></Info>
        </Col>
      </Row>

      {/* SaaS 公共的品牌组件 */}
      {
        (isNotEmptyAny(competitorInfo)) && <CommonBrandModule
          brandList={competitorInfo}
          brandData={attentionBrandTopData}
          isCityView
          inSpotevaluation
          className={ styles.brandModule}
        />
      }
      {/* {
        isNotEmptyAny(competitorInfo) && (
          <>
            <Title style={{ paddingTop: '16px' }} icon={{ iconHref: 'iconic_qushi' }}>品牌门店走势</Title>
            <CompetitorData competitorInfo={competitorInfo} isCity={true} />
          </>
        )
      } */}
      <MacroModal open={open} setOpen={setOpen} macroData={cityInfo} name={cityInfo?.name} level={3} />
    </div>
  );
};

export default CityInfo;
